/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  JudgeConfiguration,
  JudgeConfiguration$inboundSchema,
  JudgeConfiguration$Outbound,
  JudgeConfiguration$outboundSchema,
} from "./judgeconfiguration.js";
import {
  Message,
  Message$inboundSchema,
  Message$Outbound,
  Message$outboundSchema,
} from "./message.js";
import {
  VariationToolPost,
  VariationToolPost$inboundSchema,
  VariationToolPost$Outbound,
  VariationToolPost$outboundSchema,
} from "./variationtoolpost.js";

export type AIConfigVariationPatchModel = {};

export type AIConfigVariationPatch = {
  /**
   * Human-readable description of what this patch changes
   */
  comment?: string | undefined;
  /**
   * Description for agent when AI Config is in agent mode.
   */
  description?: string | undefined;
  /**
   * Instructions for agent when AI Config is in agent mode.
   */
  instructions?: string | undefined;
  messages?: Array<Message> | undefined;
  model?: AIConfigVariationPatchModel | undefined;
  modelConfigKey?: string | undefined;
  name?: string | undefined;
  published?: boolean | undefined;
  /**
   * One of 'archived', 'published'
   */
  state?: string | undefined;
  /**
   * List of tools to use for this variation. The latest version of the tool will be used.
   */
  tools?: Array<VariationToolPost> | undefined;
  /**
   * List of tool keys to use for this variation. The latest version of the tool will be used.
   */
  toolKeys?: Array<string> | undefined;
  judgeConfiguration?: JudgeConfiguration | undefined;
};

/** @internal */
export const AIConfigVariationPatchModel$inboundSchema: z.ZodType<
  AIConfigVariationPatchModel,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AIConfigVariationPatchModel$Outbound = {};

/** @internal */
export const AIConfigVariationPatchModel$outboundSchema: z.ZodType<
  AIConfigVariationPatchModel$Outbound,
  z.ZodTypeDef,
  AIConfigVariationPatchModel
> = z.object({});

export function aiConfigVariationPatchModelToJSON(
  aiConfigVariationPatchModel: AIConfigVariationPatchModel,
): string {
  return JSON.stringify(
    AIConfigVariationPatchModel$outboundSchema.parse(
      aiConfigVariationPatchModel,
    ),
  );
}
export function aiConfigVariationPatchModelFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigVariationPatchModel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigVariationPatchModel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigVariationPatchModel' from JSON`,
  );
}

/** @internal */
export const AIConfigVariationPatch$inboundSchema: z.ZodType<
  AIConfigVariationPatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  comment: z.string().optional(),
  description: z.string().optional(),
  instructions: z.string().optional(),
  messages: z.array(Message$inboundSchema).optional(),
  model: z.lazy(() => AIConfigVariationPatchModel$inboundSchema).optional(),
  modelConfigKey: z.string().optional(),
  name: z.string().optional(),
  published: z.boolean().optional(),
  state: z.string().optional(),
  tools: z.array(VariationToolPost$inboundSchema).optional(),
  toolKeys: z.array(z.string()).optional(),
  judgeConfiguration: JudgeConfiguration$inboundSchema.optional(),
});
/** @internal */
export type AIConfigVariationPatch$Outbound = {
  comment?: string | undefined;
  description?: string | undefined;
  instructions?: string | undefined;
  messages?: Array<Message$Outbound> | undefined;
  model?: AIConfigVariationPatchModel$Outbound | undefined;
  modelConfigKey?: string | undefined;
  name?: string | undefined;
  published?: boolean | undefined;
  state?: string | undefined;
  tools?: Array<VariationToolPost$Outbound> | undefined;
  toolKeys?: Array<string> | undefined;
  judgeConfiguration?: JudgeConfiguration$Outbound | undefined;
};

/** @internal */
export const AIConfigVariationPatch$outboundSchema: z.ZodType<
  AIConfigVariationPatch$Outbound,
  z.ZodTypeDef,
  AIConfigVariationPatch
> = z.object({
  comment: z.string().optional(),
  description: z.string().optional(),
  instructions: z.string().optional(),
  messages: z.array(Message$outboundSchema).optional(),
  model: z.lazy(() => AIConfigVariationPatchModel$outboundSchema).optional(),
  modelConfigKey: z.string().optional(),
  name: z.string().optional(),
  published: z.boolean().optional(),
  state: z.string().optional(),
  tools: z.array(VariationToolPost$outboundSchema).optional(),
  toolKeys: z.array(z.string()).optional(),
  judgeConfiguration: JudgeConfiguration$outboundSchema.optional(),
});

export function aiConfigVariationPatchToJSON(
  aiConfigVariationPatch: AIConfigVariationPatch,
): string {
  return JSON.stringify(
    AIConfigVariationPatch$outboundSchema.parse(aiConfigVariationPatch),
  );
}
export function aiConfigVariationPatchFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigVariationPatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigVariationPatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigVariationPatch' from JSON`,
  );
}
